import React from 'react';
import { Grid, styled } from '@mui/material';
import { Colors, Text, PrimaryButton } from 'library';
import { track } from 'shared';

export default function NoWorkersFound({ signUp }: { signUp: () => void }) {
    return (
        <Grid container xs={12} justifyContent="center" height="fit-content">
            <Grid container xs={12} justifyContent="flex-start" height="fit-content">
                <NotInYourAreaContainer>
                    <Text>
                        We don't have any available profiles that match your search right now, but new teachers are
                        joining us all the time!
                    </Text>
                </NotInYourAreaContainer>
            </Grid>
            <Grid
                container
                xs={12}
                alignItems="center"
                style={{
                    backgroundColor: Colors.lightTurq,
                    borderRadius: 16,
                    padding: 20,
                    marginTop: 10,
                }}
                direction="column"
                height="fit-content"
            >
                <Text variant="display" textStyle={{ marginTop: 10, width: '70%', textAlign: 'center' }}>
                    We're expanding quickly! Make an account to be notified about new teachers in your area.
                </Text>
                <PrimaryButton
                    buttonStyle={{
                        width: 'fit-content',
                        height: 'fit-content',
                        marginTop: 20,
                        marginBottom: 10,
                    }}
                    onClick={() => {
                        track('Unsupported Region Customer Clicked Sign Up Button');
                        signUp();
                    }}
                >
                    Create Free Account
                </PrimaryButton>
            </Grid>
        </Grid>
    );
}

const NotInYourAreaContainer = styled('div')({
    backgroundColor: Colors.lightTurq,
    border: `1px solid ${Colors.turquoise}`,
    borderRadius: 16,
    display: 'flex',
    height: 'fit-content',
    padding: 15,
    width: 'fit-content',
});
